/**
 * @generated SignedSource<<0c964fdc4db048aa27656ed4d3cedc32>>
 * @relayHash c7d5e8e948efa0a5f4521d77275a114a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SupportWebsiteNavEntryPointQuery } from './SupportWebsiteNavEntryPointQuery.graphql';

const node: PreloadableConcreteRequest<SupportWebsiteNavEntryPointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "df21ac0704295fb549bc8443e0370ead496e2d268178d86e9d1a286329b37b9d",
    "metadata": {},
    "name": "SupportWebsiteNavEntryPointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
